/* Сгенерировано tools/lucide-font.cjs — не править руками. */

/** Имя иконки кабинета → символ в assets/fonts/lucide.ttf. */
export const ICON_GLYPHS = {
  feed: '\ue106',
  people: '\ue1a4',
  devices: '\ue371',
  dashboard: '\ue1c1',
  personnel: '\ue617',
  attendance: '\ue2b7',
  logs: '\ue45f',
  profile: '\ue461',
  search: '\ue151',
  plus: '\ue13d',
  chevron: '\ue06f',
  chevronDown: '\ue06d',
  chevronUp: '\ue070',
  chevronLeft: '\ue06e',
  check: '\ue06c',
  close: '\ue1b2',
  edit: '\ue1f9',
  trash: '\ue18e',
  refresh: '\ue145',
  logout: '\ue10e',
  settings: '\ue154',
  bulk: '\ue529',
  theme: '\ue2b2',
  language: '\ue0fe',
  bell: '\ue059',
  send: '\ue152',
  qr: '\ue1df',
  eye: '\ue0ba',
  eyeOff: '\ue0bb',
  copy: '\ue09e',
  calendar: '\ue063',
  image: '\ue0f6',
  home: '\ue0f5',
  building: '\ue290',
  clock: '\ue087',
  shield: '\ue158',
  warning: '\ue193',
  info: '\ue0f9',
  lock: '\ue10b',
  unlock: '\ue10c',
  mail: '\ue10f',
  link: '\ue4a3',
  camera: '\ue064',
  desktop: '\ue11d',
  recorder: '\ue0ed',
  wallet: '\ue204',
  play: '\ue13c',
  user: '\ue468',
  panel: '\ue12a',
  updown: '\ue211',
  more: '\ue0b6',
  menu: '\ue115',
  download: '\ue0b2',
  filter: '\ue460',
  sort: '\ue37d',
  external: '\ue5a4',
  maximize: '\ue113',
  minimize: '\ue11b',
  fullscreen: '\ue534',
  stop: '\ue083',
  grid: '\ue0ff',
  bookmark: '\ue060',
  repeat: '\ue146',
  monitorPlay: '\ue485',
  pause: '\ue12e',
  rotate: '\ue148',
  ptz: '\ue121',
  arrowUp: '\ue04a',
  arrowDown: '\ue042',
  arrowLeft: '\ue048',
  arrowRight: '\ue049',
  arrowUpLeft: '\ue04b',
  arrowUpRight: '\ue04d',
  arrowDownLeft: '\ue043',
  arrowDownRight: '\ue045',
  zoomIn: '\ue1b6',
  zoomOut: '\ue1b7',
} as const;

export type IconGlyphName = keyof typeof ICON_GLYPHS;
